import { PdfHelper } from "../../../helpers/PdfHelper";

/* eslint-disable */
export default class RequisitionPdf
{
    
    docVer = 'GM-ADF-08 REV:03'; 
   
    /**
     * print pdf
    */
    static printDocument(data)
    {
        const builder = new RequisitionPdf();
        const document = builder.getDocument(data);
        PdfHelper.createPdf(document);
    }

    /**
     * open pdf
     */
    static openDocument(data)
    {
        console.log(data, "dat");
        const builder = new RequisitionPdf();
        const document = builder.getDocument(data);
        PdfHelper.open(document);
    }





    

    getDocument(data) {
        const pdfHelper = new PdfHelper();
        const feePdf = new RequisitionPdf();
       
        return {
            info: {
                title: `Requisición`,
                author: 'Chronos',
            },
            styles: pdfHelper.getStyles(),
            // a string or { width: number, height: number }
            pageSize: 'letter',
            // by default we use portrait, you can change it to landscape if you wish
            pageOrientation: 'portrait',
            // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins 
            pageMargins:[70,100,70,50],
            // header:  pdfHelper.getHeader("COTIZACIÓN", "COT00004", "2023/02/03"),
           
            header: function(currentPage, pageCount) { 
                return pdfHelper.getHeader(currentPage, data.data.requisition_id, data.data.date_pdf, data.data?.secondary_logo??"")
            },
            footer: function(currentPage, pageCount) { 
                return feePdf.getFooter(currentPage, pageCount, data.data.address_data, null, null, feePdf.docVer)
            },
            // absolutePosition: {x: 230, y: -15}
            content: [
               
                //header
                // pdfHelper.getPrimaryHeader("REQUISICIÓN", data.data.requisition_id, data.data.date_pdf, data.data.primary_logo),
                pdfHelper.getPrimaryHeader("REQUISICIÓN", data.data.requisition_id, data.data.date_pdf, data.data.primary_logo),

                

                //tanks
                this.getThanks(data.data.client, data.data.client_product),

                //table
                this.getTable(data.supplies),
                this.getCommentsSpecVig(data.data.observations),

                // //footer space
                // this.getFooterSpace(this.getFooterSize(data.data.observations, "")),

                            
            ],
            
            
            
        
        };
    }

    getCommentsSpecVig(comments)
    {
        let commentTitle = "OBSERVACIONES:"
        
        let items = [];
        //comments
        if((comments !== "" && comments !== null) ){
            items.push(
                {
                    text:`${commentTitle} `,
                    style:['footerComentaryTitle']
                },
                {
                    text:`${comments} `,
                    style:['marginFooterMessages'],
                },
            )
        }
       

        return [
            //comments, conditions & validity
            {
                margin:[0,5,0,0],
                style:['footerMessage'],
                stack:[
                    ...items,
                    
                ]
            },
        ]
    }

    getFooterSize(comments, conditions)
    {
        return 24;
        // //no comments no conditions
        // if((comments === "" || comments === null) && (conditions === "" || conditions === null))
        //     return 164;
        // //no comments with conditions
        // if((comments === "" || comments === null) && (conditions !== "" && conditions !== null))
        //     return 180;
        // //no condition with comments
        // if((conditions === "" || conditions === null) && (comments !== "" && comments !== null))
        //     return 199;
        // //default 
        // return 210;

        
    }

    getFooter(currentPage, pageCount, address_data, phone, email, docRev)
    {
        const pdfHelper = new PdfHelper();
        

        // if(currentPage === 1 && pageCount != 1)
        //     return {};
        if(currentPage === pageCount){
            return [
                //bottom line
                {
                    absolutePosition: {x: 0, y: 0},
                        canvas: 
                       [
                          
                           {
                                type: 'polyline',
                                lineWidth: 3,
                                closePath: true,
                                color: '#005e7f',
                                lineColor: '#005e7f',
                                points: [{ x: 0, y: 45 }, { x: 0, y: 60 }, { x: 1000, y: 60}, { x: 1000, y: 45 }]
                            },
                           
                       ]
                },
                
                


                //contact info
                pdfHelper.getContactInfo(docRev),
            
            ];
        }
        return {};

    }

    

    getFooterSpace(hSize)
    {
        return  {
            unbreakable: true,          
            columns: [
                
                {
                    canvas:[
                        {
                            type: 'rect',
                            x: 20,
                            y: 0,
                            w: 1,
                            h: hSize,
                            r: 5,
                            
                            // lineWidth: 10,
                            lineColor: '#000',
                        },
                    ]
                }
             ],
             columnGap: 10,
        };
    }

    getThanks(client, project){
        if(project == "DEFAULT" || project == "default")
            project = "";
        return [
            {
	            style:['marginTanks'],
	            stack:[
	                {
	                    style:['thanksTitle'],
	                    text: `${client}`
	                },
                    {
	                    style:['thanksTitle2'],
	                    text: `${project}`
	                },
	                // {
	                //     style:['thanksSub'],
	                //     text: header === "" ? "En atención a su amable solicitud de cotización para servicios del régimen Recinto Fiscalizado Estratégico, dejo a su consideración el siguiente presupuesto."
                    //     : header
	                // }
                ]
	        }
        ];
    }


    getTable(items)
    {
        //table items
        const tableItems = [];

        items.forEach((item, index) => {
            tableItems.push(
                [
                    {
                        text:`${index+1}`,
                        style:['tableItemSecondary', 'tableItemSecondaryFirst'],
                    },
                    {
                        text:`${item.name}`,
                        style:['tableItemPrimary'],
                    },
                    
                    {
                        text:`${item.unit}`,
                        style:['tableItemSecondary', 'tableItemSecondaryMargin']
                    },
                    {
                        text:`${item.quantity}`,
                        style:['tableItemSecondary', 'tableItemSecondaryMarginLast'],
                    }
                ],
            )
        });


        return {
            margin:[0,0,0,0],
            layout:  {
                hLineWidth: function (i, node) {
                    if(i === 1)
                        return 3;
                    return 3
                },
                vLineWidth: function (i, node) {
                    return 0;
                },
                hLineColor: function (i, node) {
                    if(i === 1)
                         return '#005e7f'
                    return '#fff'
                },
                //paddingLeft: function(i, node) { return 40; },
                //paddingBottom: function(i, node) { return 20; },
                // fillColor: function (rowIndex, node, columnIndex) {
                //     if(rowIndex === 0)
                //         return '#F2F2F2';
                    
                    
                //     return (rowIndex % 2 === 0) ? '#FFFFFF' : "#FCFCFC";
                // }
            },
            table:{
                headerRows: 1,
                widths: [ 20, '*', 80,80 ],
                heights: [10, 10, 10,10],
                body:[
                    //headers
                    [
                        {
                            text:"#",
                            style:['tableHeaderFont','alignCenter'],
                            margin:[0,0,0,7],
                        },
                        {
                            text:"Descripción",
                            style:['tableHeaderFont'],
                            margin:[0,0,0,7]
                        },
                        
                        {
                            text:"Unidad",
                            style:['tableHeaderFont','alignCenter'],
                            margin:[0,0,0,7]
                        },
                        {
                            text:`Cantidad`,
                            style:['tableHeaderFont','alignCenter'],
                            margin:[0,0,0,7]
                        }
                    ],
                    //items
                    ...tableItems,
                ]
            }
        }
    }
}